import React, { Suspense, useEffect, useState } from 'react';
import { APIServices } from '../../../hooks/fetchAPI';
import { data, useNavigate, useParams } from 'react-router';
import { useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import { pageRoutes } from '../../../routes/pageRoutes';

const PersonalityExamTab = React.lazy(() => import('./PersonalityExamTab'));
const ExamList = React.lazy(() => import('../Exam/ExamList'));
const ExamGuidelines = React.lazy(() => import('./ExamGuidelines'));
const WarningNotif = React.lazy(() => import('../Modal/WarningNotif'));

function PersonalityExam() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [dataList, setData] = useState([]);
    const [examContent, setExamContent] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [activeStep, setActiveStep] = useState(parseFloat(id));
    const [showDashboard, setShowDashboard] = useState(true);
    const [completed, setCompletedExamType] = useState([])
    const [isTabActive, setIsTabActive] = useState(true);
    const [switchCount, setSwitchCount] = useState(0);
    const [openWarning, setOpenWarning] = useState(false);

    const user = useSelector((state) => state.user.userData)

    const fetchDataList = async () => {
        try {
            const response = await APIServices.get({ url: `/person-exam/fetch-person-exam-status`, payload: { user_id: user?.id } });

            if (response && response.status === 200) {
                setData(response?.data?.data);
                setCompletedExamType(
                    response?.data?.data
                        .filter(section => section.completed === true)
                        .map(section => section.exam_type_id)
                );
            } else {
                console.error("Failed to log exam time:", response);
            }
        } catch (error) {
            console.error("Error logging exam time:", error);
        }
    }

    const fetchDataContent = async () => {
        setIsLoading(true);
        try {
            const response = await APIServices.get({ url: `/person-exam/fetch-exam-person`, payload: { id: id } });

            if (response && response.status === 200) {
                setExamContent(response?.data);
            } else {
                console.error("Failed to log exam time:", response);
            }
        } catch (error) {
            console.error("Error logging exam time:", error);
        } finally {
            setIsLoading(false);
        }
    }


    useEffect(() => {
        fetchDataList();
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    useEffect(() => {
        fetchDataContent();
        setActiveStep(parseFloat(id) - 1)
        if (completed.includes(parseFloat(id))) {
            navigate(`/personality-exam/${parseFloat(id) + 1}`)
        }
        if (parseFloat(id) === 6) {
            navigate(pageRoutes.VIDEOINTERVIEW);
        }
    }, [id, completed]);

    const handleVisibilityChange = async () => {
        if (document.hidden) {
            setIsTabActive(false);
            setSwitchCount((prev) => prev + 1);
            setOpenWarning(true);

            const response = await APIServices.post({
                url: `/switch-tabs`,
                payload: { "section_id": 3 },
            });

            if (response && response.status === 201) {
                console.log("User switched tab!");
            } else {
                console.error("Failed to log:", response);
            }

            // console.log(" User switched tab!");
        } else {
            setIsTabActive(true);
            // console.log("User returned to exam tab.");
        }
    };

    const handleClose = (event, reason) => {
        if (reason === "clickaway") return;
        setOpenWarning(false);
    };


    return (
        <div>
            <Suspense fallback={<div></div>}>
                <WarningNotif
                    open={openWarning}
                    onClose={handleClose}
                    switchCount={switchCount}
                />
                {showDashboard ?
                    <ExamGuidelines showDashboard={showDashboard} setShowDashboard={setShowDashboard} />
                    : <div className="flex flex-row lg:flex-row gap-4">
                        <ExamList activeStep={activeStep} shuffledSections={dataList} />
                        {isLoading ?
                            <div className='w-full flex justify-center items-center self-center'>
                                <CircularProgress />
                            </div> : <PersonalityExamTab examContent={examContent} isLoading={isLoading} />}
                    </div>}
            </Suspense>
        </div>
    )
}

export default PersonalityExam
